module.exports = __webpack_public_path__ + "img/XAI7.74fd7445.jpg";